module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_113_9.e1eb17a7.pdf";